import { Link } from 'react-router-dom';
import { MapPin, ArrowUpRight } from 'lucide-react';

// India + international cities served — keyword-anchored copy for
// "Personal Stylist Chennai", "Personal Stylist Mumbai" etc.
// Visually subtle, content-rich. Drop into homepage or service pages.
const CITIES = [
  { city: 'Bengaluru', kind: 'Studio', note: 'Founder-led private styling, in-home wardrobe edits and personal shopping days.' },
  { city: 'Chennai', kind: 'Travel-To', note: 'Personal styling and image consulting visits across Chennai \u2014 weddings, corporate engagements and private clients.' },
  { city: 'Mumbai', kind: 'Travel-To', note: 'On-location wardrobe edits and personal shopping experiences for Mumbai-based founders, executives and grooms.' },
  { city: 'Delhi & NCR', kind: 'Travel-To', note: 'Image consulting and shopping experiences across Delhi, Gurugram and Noida.' },
  { city: 'Hyderabad', kind: 'Travel-To', note: 'Private engagements for Hyderabad professionals, founders and wedding clients.' },
  { city: 'Pune', kind: 'Travel-To', note: 'Wardrobe edits and shopping experiences for Pune-based clients.' },
  { city: 'Virtual', kind: 'Anywhere', note: 'Remote Style Diagnosis and Virtual International Shopping for clients across India and abroad.' },
];

export default function CitiesServed() {
  return (
    <section className="py-20 lg:py-28 bg-ivory" aria-label="Cities served by Mondaine Style across India">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-12 reveal">
          <div className="max-w-2xl">
            <p className="text-[11px] tracking-[0.3em] uppercase text-champagne-deep mb-6">India &amp; Beyond</p>
            <h2 className="font-serif text-4xl lg:text-5xl leading-[1.05] text-charcoal">
              A personal stylist <em className="italic-accent">across India.</em>
            </h2>
            <p className="mt-6 text-charcoal/70 leading-relaxed">
              Mondaine Style is based in Bengaluru and serves private clients across India \u2014 from
              Chennai and Mumbai to Delhi, Hyderabad and Pune \u2014 plus virtual engagements for clients
              anywhere in the world.
            </p>
          </div>
          <Link
            to="/book-consultation"
            data-testid="cities-cta"
            className="group inline-flex items-center gap-2 text-[11px] tracking-[0.22em] uppercase text-charcoal hover:text-champagne-deep transition-colors"
          >
            Request A Travel Engagement <ArrowUpRight size={14} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
          </Link>
        </div>

        <ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-charcoal/10 reveal">
          {CITIES.map((c) => (
            <li key={c.city} className="bg-ivory p-6 lg:p-7" data-testid={`city-${c.city.toLowerCase().replace(/\s|&/g, '-')}`}>
              <div className="flex items-center gap-2 text-champagne-deep">
                <MapPin size={14} />
                <span className="text-[10px] tracking-[0.28em] uppercase">{c.kind}</span>
              </div>
              <h3 className="font-serif text-2xl lg:text-3xl mt-3 text-charcoal">{c.city}</h3>
              <p className="mt-3 text-sm text-charcoal/70 leading-relaxed">{c.note}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
